import useSWRImmutable, { BareFetcher, SWRResponse } from 'swr';

import { SkillDiscoveryResponse as Response } from '@gmm/sdk-voodoo/skillDiscovery';
import { useCurrentTeacher } from '~/lib/hooks/useCurrentTeacher';
import { voodooSdkFetcher } from '~/lib/swr';
import { useSelectedCollection } from '~/work/skillDiscovery/useCollections';
import { useSelectedGrade } from '~/work/skillDiscovery/useGrades';

import { getValueKey } from './utils';
import { useEffect } from 'react';
import { useExerciseLastUpdatedStore } from '../../stores';
import { AxiosError } from 'axios';
import { skillDiscoveryErrorStore } from '../errorStore';

export type UseSkillDiscovery = SWRResponse<Response, AxiosError>;

export const useSkillDiscovery = (): UseSkillDiscovery => {
  const setError = skillDiscoveryErrorStore(state => state.setError);
  const { data: teacher } = useCurrentTeacher();
  const [selectedGrade] = useSelectedGrade();
  const [selectedCollection] = useSelectedCollection();
  const [setLastUpdated] = useExerciseLastUpdatedStore(state => [
    state.setLastUpdated,
  ]);
  const swrKey = getValueKey({ selectedCollection, selectedGrade, teacher });

  const swrResponse = useSWRImmutable(swrKey, {
    fetcher: voodooSdkFetcher as BareFetcher<Response>,
  });

  if (swrResponse.error) {
    setError(swrResponse.error);
  }

  useEffect(() => {
    if (swrResponse.data) {
      setLastUpdated(swrResponse.data);
    }
  }, [swrResponse.data]);

  return swrResponse;
};
